import Box from '@mui/material/Box';
import CircularProgress from '@mui/material/CircularProgress';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import {ToastContentProps} from 'react-toastify';

export type NotificationData = {
  message: string;
  title?: string;
  showSpinner?: boolean;
};

type NotificationContentProps = Pick<
  ToastContentProps<NotificationData>,
  'data'
> & {
  toastProps?: {
    hideProgressBar?: boolean;
  };
};

export const NotificationContent = ({
  data,
  toastProps,
}: NotificationContentProps) => {
  return (
    <Stack
      sx={{
        flexDirection: 'row',
        gap: 1.5,
        alignItems: 'center',
        width: '100%',
        minWidth: 0,
        marginBlockEnd: !toastProps?.hideProgressBar ? 1 : 0,
      }}
    >
      {data.showSpinner && (
        <CircularProgress color="inherit" size={20} sx={{flexShrink: 0}} />
      )}
      <Box sx={{width: '100%'}}>
        {data.title && (
          <Typography
            variant="subtitle1"
            sx={{
              fontWeight: 500,
            }}
          >
            {data.title}
          </Typography>
        )}

        <Typography variant="body2">{data.message}</Typography>
      </Box>
    </Stack>
  );
};

export default NotificationContent;
